import { Spotlight as AkSpotlight } from '@atlaskit/onboarding';
import type { SpotlightProps } from '@atlaskit/onboarding/types';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Spotlight: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: SpotlightProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<SpotlightProps>(AkSpotlight);
